import { PATIENT_TYPE } from "Constants/PatientManagementConstants";

// Maps Boolean inSystem to patient type, defaults to InSystem if inSystem is undefined
export const getPatientType = (inSystem) => {
  return inSystem !== false ? PATIENT_TYPE.InSystem : PATIENT_TYPE.Guest;
};
